/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { SELECTION_STYLE_CONTEXT_DO_NOT_USE } from '@atlaskit/menu';
import { N10, N500 } from '@atlaskit/theme/colors';
const sidebarMinWidth = '240px';
const sideNavStyles = css({
  display: 'flex',
  width: '100%',
  minWidth: sidebarMinWidth,
  height: '100%',
  position: 'relative',
  flexDirection: 'column',
  backgroundColor: `var(--ds-surface, ${N10})`,
  color: `var(--ds-text-subtle, ${N500})`,
  overflow: 'hidden'
});

/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */
const SideNavigation = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    testId,
    label
  } = props;
  return jsx("nav", {
    ref: ref,
    "data-testid": testId,
    "aria-label": label,
    css: sideNavStyles
  }, jsx(SELECTION_STYLE_CONTEXT_DO_NOT_USE.Provider, {
    value: "notch"
  }, children));
});
export default SideNavigation;